/*
 * TABLEAUX TENDANCES - Favoris / Wishlist
 *
 * PHASE 1 (actuelle) :
 * - Le stockage des favoris se fait uniquement en local, via localStorage
 *   (clé "tt_wishlist"), sur l'appareil du visiteur.
 * - Aucun appel réseau, aucune base de données, aucun serveur.
 * - Aucune donnée Shopify Admin (produits, métachamps, clients, commandes...)
 *   n'est lue ni modifiée par ce fichier.
 *
 * PHASE 2 (préparée, non implémentée) :
 * - Une future version pourra envoyer chaque ajout/retrait de favori vers
 *   une app Shopify, une base de données, ou un endpoint interne, afin de
 *   comptabiliser les produits les plus aimés (statistiques de popularité).
 * - Le point d'accroche prévu pour cela est la fonction
 *   trackWishlistEventPhase2() ci-dessous : elle est actuellement un no-op
 *   (ne fait rien), à décommenter/implémenter le jour où l'endpoint existe.
 * - Cette évolution ne devra toujours pas écrire dans l'admin Shopify
 *   directement depuis le navigateur du client.
 */
(function () {
  var STORAGE_KEY = 'tt_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isFavorite(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  // PHASE 2 (non active) : point d'accroche pour envoyer un événement like/unlike
  // vers un futur endpoint de statistiques. Ne fait rien en phase 1.
  function trackWishlistEventPhase2(handle, active) {
    // Exemple d'implémentation future (désactivé pour l'instant) :
    // fetch('/apps/wishlist-stats/track', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ handle: handle, active: active })
    // });
  }

  function toggleFavorite(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    updateCountBubble();
    var active = list.indexOf(handle) !== -1;
    trackWishlistEventPhase2(handle, active);
    return active;
  }

  function updateCountBubble() {
    var count = getWishlist().length;
    var bubble = document.querySelector('.wishlist-count-bubble');
    var bubbleText = bubble ? bubble.querySelector('span[aria-hidden]') : null;
    if (!bubble) return;
    if (count > 0) {
      bubble.hidden = false;
      if (bubbleText) bubbleText.textContent = count;
    } else {
      bubble.hidden = true;
    }
  }

  function initButtons(scope) {
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';
      var handle = btn.getAttribute('data-wishlist-toggle');
      if (isFavorite(handle)) btn.classList.add('is-favorite');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var active = toggleFavorite(handle);
        btn.classList.toggle('is-favorite', active);
        document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { handle: handle, active: active } }));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateCountBubble();
  });

  window.TTWishlist = {
    getWishlist: getWishlist,
    isFavorite: isFavorite,
    toggleFavorite: toggleFavorite,
    updateCountBubble: updateCountBubble,
    initButtons: initButtons
  };
})();
